const A = "/assets/winners";

export const PLACES = {
  1: { label: "1st place", prize: "150,000", tone: "gold" },
  2: { label: "2nd place", prize: "70,000", tone: "silver" },
  3: { label: "3rd place", prize: "30,000", tone: "bronze" },
};

export const TRACKS = [
  {
    key: "ai", title: "AI Track", kicker: "Track 01", accent: "sky",
    winners: [
      { rank: 1, slug: "u-reach", name: "U-Reach", icon: `${A}/icon-ureach.webp`, photo: `${A}/photo-ureach.webp` },
      { rank: 2, slug: "subguard", name: "SubGuard", icon: `${A}/icon-subguard.webp`, photo: `${A}/photo-subguard.webp` },
      { rank: 3, slug: "icarus-assistant", name: "Icarus Assistant", icon: `${A}/icon-icarus.webp`, photo: `${A}/photo-icarus.webp` },
    ],
  },
  {
    key: "web3", title: "Web3 Track", kicker: "Track 02", accent: "violet",
    winners: [
      { rank: 1, slug: "ubotpay", name: "Ubotpay", icon: `${A}/icon-ubotpay.webp`, photo: `${A}/photo-ubotpay.webp` },
      { rank: 2, slug: "flowflow", name: "FlowFlow", icon: `${A}/icon-flowflow.webp`, photo: `${A}/photo-flowflow.webp` },
      { rank: 3, slug: "lazywallet", name: "LazyWallet", icon: `${A}/icon-lazywallet.webp`, photo: `${A}/photo-lazywallet.webp` },
    ],
  },
];

const ORD = { 1: "1st", 2: "2nd", 3: "3rd" };
export const AWARDS = Object.fromEntries(
  TRACKS.flatMap((t) => t.winners.map((w) => [w.slug, { rank: w.rank, label: `${ORD[w.rank]} · ${t.title}` }]))
);

export const SPONSORS = [
  { name: "DTC Group", src: `${A}/logo-dtc.webp` },
  { name: "ElevenLabs", src: `${A}/logo-elevenlabs.webp`, small: true },
  { name: "Tokenomist", src: `${A}/logo-tokenomist.webp` },
];

export const PARTNERS = [
  { name: "Contribution DAO", src: `${A}/logo-contribution.webp` },
  { name: "Avalanche", src: `${A}/logo-avalanche.webp` },
  { name: "Team1 Thailand", src: `${A}/logo-team1.webp` },
  { name: "Yellow", src: `${A}/logo-yellow.webp` },
  { name: "CUBS", src: `${A}/logo-cubs.webp`, tall: true },
  { name: "HooRay", src: `${A}/logo-hooray.webp` },
];

export const STATS = [
  { value: "380", label: "Hackers" },
  { value: "24", label: "Hours" },
  { value: "99", label: "Projects" },
];
